<!--FastBI产品-->
<template>
  <div class="xz_buyDialog">
    <el-dialog :before-close="cancel" :title="isAdd == 'triall' ? '客户试用' : '购买产品'" :visible.sync="visible"
      :close-on-click-modal="false" width="560px" :loading="dialog_loading">
      <el-form :model="form" ref="form" :rules="formRules">
        <el-form-item :label-width="formLabelWidth" label="管理员姓名" prop="name">
          <el-input v-model="form.name" :disabled="isAdd == 'buy' || isAdd == 'module_buy' || isAdd == 'package'"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="管理员账号" prop="mobile">
          <el-input v-model="form.mobile" :disabled="isAdd == 'buy' || isAdd == 'module_buy' || isAdd == 'package'"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="企业名称" prop="org_name">
          <el-select v-model="form.org_name" remote placeholder="请选择" @change="selectOrgs" @focus="remoteMethod"
            :loading="orgLoading" :disabled="isAdd == 'buy' || isAdd == 'module_buy' || isAdd == 'package'">
            <el-option v-for="item in orgs" :key="item.value" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="企业ID" prop="org_code">
          <el-input placeholder="请输入企业ID" v-model="form.org_code" :disabled="isAdd == 'module_buy'"> </el-input >
        </el-form-item>

        <el-form-item  :label-width="formLabelWidth" label="选择应用" prop="app_id">
          <el-select filterable v-model="form.app_id" @change="selectApps" placeholder="请选择" :disabled="isAdd == 'module_buy'">
            <el-option v-for="item in apps" :key="item.name" :label="item.name" :value="item.value">
            </el-option>
          </el-select >
        </el-form-item>

        <el-form-item v-if="isAdd !== 'package'" :label-width="formLabelWidth" label="选择版本" prop="module_id">
          <el-select v-model="form.module_id" placeholder="请选择" :disabled="isAdd == 'module_buy'">
            <el-option v-for="item in modules" :key="item.name" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isAdd === 'package'" :label-width="formLabelWidth" label="选择流量包" prop="module_id">
          <el-select v-model="form.module_id" placeholder="请选择" @change="selectPackages">
            <el-option v-for="item in packages" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isAdd === 'package'" :label-width="formLabelWidth" label="选择产品年度" prop="periods">
          <el-select v-model="form.periods" placeholder="请选择" multiple value-key="index" collapse-tags
            v-loading="periodsLoading">
            <el-option v-for="item in periods" :key="item.name" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isAdd === 'buy' || isAdd == 'module_buy' || isAdd === 'add'" :label-width="formLabelWidth"
          :label="isAdd === 'triall' ? '试用时长' : '购买时长'">
          <template v-if="isAdd != 'triall'">
            <el-input-number style="text-align: center;" size="small" v-model="form.new_months" :min="1" :max="100"
              :step="1"></el-input-number>
            <span style="margin-left: 10px;">年</span>
          </template>
          <template v-else>
            <el-select v-model="form.months" placeholder="请选择">
              <template v-if="isAdd != 'triall'">
                <el-option v-for="item in buyTime" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </template>
            </el-select>
          </template>

        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="备注" prop="note">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.note"> </el-input>
        </el-form-item>
        <!-- </div> -->
        <!-- <div v-if="isAdd != 'triall'">
          <el-form-item :label-width="formLabelWidth" label="支付方式" prop="pay_type">

            <el-radio-group v-model="form.pay_type">

              <el-radio :label="1">安捷云专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item>
        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <div class="price">订单:<span>¥10000</span></div> -->
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button v-if="isAdd == 'triall'" class="primary" @click="triallClick">创建试用</el-button>
        <el-button v-else class="primary" @click="buyClick">预览价格</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getXZEditions } from '@/api/auth';
import {
  trailAFCloud, getAFCloudApps, queryOrgs, buyAFCloud, buyAFCloudPrice, getPackageBuyApp, getPeriodsBuyApp, buyAFCloudPackagePrice
} from '@/api/afCloud';
import { checkAgentPrice } from '@/api/agent';
import { payType } from '@/utils/dataDict';
import { payVerify } from '@/utils/pay';
import { getVersionOption, getseriesNameOption, extractYearFromDates } from './utils';
export default {
  data() {
    return {
      dialog_loading: false,
      new_expire_time: '',
      modifyId: null,
      isAdd: 'add',
      currentBuyTime: null,
      payType,
      visible: false,
      formLabelWidth: '110px',
      form: {
        name: "", //姓名
        mobile: "", //管理员账号
        org_code: "", //企业id
        org_name: "", //企业名称
        months: "", //购买月数
        module_id: "", //模块id
        pay_type: 1,
        note: "",
        app_id: "",
        periods: [],
        new_months:1,
      },
      modules: [],
      formRules: {
        mobile: [
          {
            required: false,
            message: '请输入管理员账号',
            trigger: 'blur',
          },
        ],
        org_code: [
          {
            required: true,
            message: '请选择企业ID',
            trigger: 'blur',
          },
        ],
        app_id: [
          {
            required: true,
            message: '请选择应用',
            trigger: 'blur',
          },
        ],
        module_id: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        periods: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ]

      },
      isSelectAll: false,
      apps: [],
      orgs: [],  // 企业
      buyTime: [
        { name: '一年', value: 12 },
        { name: '两年', value: 24 },
        { name: '三年', value: 36 }
      ],
      orgLoading: false,
      packages: [],
      periods: [],
      periodsLoading: false
    };
  },
  mounted() {
    this.getMpdules()
    this.getUserInfo();
  },
  methods: {
    getMpdules() {
      getAFCloudApps().then(res => {
        this.apps = res.map(item => {
          return {
            name: item.name,
            value: item.id,
            versions: item.versions
          }
        });
        console.log(this.apps,'this.apps');
        
      })
    },
    selectOrgs(val) {
      for (const o of this.orgs) {
        console.log(val, o);

        if (o.name == val) {
          this.form.org_code = o.value
          break
        }
      }
    },
    // 选择流量包
    selectPackages(val) {
      // this.dialog_loading = true;
      this.periodsLoading = true
      this.form.periods = [];
      console.log(val);

      getPeriodsBuyApp({
        mobile: this.form.mobile,
        org_code: this.form.org_code,
        module_id: val
      }).then(res => {
        this.periods = extractYearFromDates(res);
        this.periodsLoading = false

        // this.dialog_loading = false;

      }).catch(err => {
        this.periodsLoading = false

        // this.dialog_loading = false;

      })

    },
    selectApps(val) {
      
      this.form.module_id = '';
      this.periods = []
      if (this.isAdd == 'package') {
        // 需要取到流量包列表
        this.form.periods = [];
        this.dialog_loading = true;
        getPackageBuyApp({ app_id: val }).then(res => {
          this.dialog_loading = false;
          console.log(res);

          this.packages = res
        }).catch(err => {
          this.dialog_loading = false
        })
      } else {
        for (const app of this.apps) {
          if (val == app.value) {
            this.modules = app.versions.map(item => {
              return {
                name: item.name,
                value: item.id
              }
            })

            break
          }
        }
      }

    },
    getQrgs(obj) {
      return queryOrgs(obj)
    },
    remoteMethod() {
      if (this.form.mobile) {
        // this.orgLoading = true
        queryOrgs({ phone: this.form.mobile }).then(res => {
          this.orgLoading = false
          this.orgs = res.map(item => {
            return {
              value: item.code,
              name: item.name
            }
          })
        }).catch(err => {
          this.orgLoading = false
        })
      } else {
        this.$message({
          type: 'error',
          message: '管理员账号不能为空'
        });
      }

    },
    getUserInfo() {
      this.userInfo = this.$store.getters.userInfo;
    },


    formatDate(num) {
      let result = num + '';
      if (result.length < 2) {
        result = '0' + result;
      }
      return result;
    },
    show(obj) {
      console.log(obj);

      this.buyTime = [
        { name: '一年', value: 12 },
        { name: '两年', value: 24 },
        { name: '三年', value: 36 },
      ];
      this.visible = true;
      if(this.isAdd  == 'module_buy'){
        this.modifyId = obj.id;
        this.form.mobile = obj.mobile;
        this.form.org_code = obj.org_code;
        this.form.org_name = obj.org_name;
        this.form.name = obj.name;
        this.form.months = 12
        for (let index = 0; index < this.apps.length; index++) {
          const app = this.apps[index];
          const versions = app.versions;
          for (let j = 0; j < versions.length; j++) {
            const version = versions[j];
            if (version.id == obj.module_id){
              this.form.app_id = app.value;
              
              this.selectApps(app.value)
              break
            }
            
          }
        }
        this.form.module_id = obj.module_id;
        

      }else if (this.isAdd == 'buy' || this.isAdd == 'package') {
        this.modifyId = obj.id;
        this.form.mobile = obj.mobile;
        this.form.org_code = obj.org_code;
        this.form.org_name = obj.org_name;
        this.form.name = obj.name;
        this.form.months = 12
      } else if (this.isAdd == 'triall') {
        this.form.months = 1;
      } else if (this.isAdd == 'add') {
        this.form.months = 12;
      }
    },
    getips() {
      if (this.auth_ips.length == 1) {
        return this.auth_ips[0].value;
      }
      return this.auth_ips
        .map((item) => {
          return item.value;
        })
        .join(',');
    },
    geInternaltips() {
      if (this.Internal_auth_ips.length == 1) {
        return this.Internal_auth_ips[0].value;
      }
      return this.Internal_auth_ips.map((i) => i.value).join(',');
    },
    triallClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {}
          obj.org_code = this.form.org_code;
          obj.org_name = this.form.org_name;
          obj.mobile = this.form.mobile;
          obj.months = this.form.months;
          obj.module_id = this.form.module_id;
          obj.note = this.form.note;
          obj.name = this.form.name;
          trailAFCloud(obj)
            .then(() => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '申请试用成功',
              });
              this.resetForm();
              this.$parent.getAuthData();
              this.visible = false;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm() {
      this.form = {
        name: "", //姓名
        mobile: "", //管理员账号
        org_code: "", //企业id
        org_name: "", //企业名称
        months: "", //购买月数
        module_id: "", //模块id
        pay_type: 1,
        note: "",
        app_id: "",
        periods: [],
        new_months:1
      };
      this.modules = [];
      this.packages = [];
      this.periods = [];
      this.orgs = []

    },
    buyClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {

          if (this.isAdd == 'add' || this.isAdd == 'buy' || this.isAdd == 'module_buy') {
            console.log(this.form.new_months);
            
            let months = Number(this.form.new_months)*12    
            this.form.months = months

            let obj = {
              months: months,
              pay_type: this.form.pay_type,
            };
            obj.buyout = false
            obj.org_code = this.form.org_code;
            obj.org_name = this.form.org_name;
            obj.mobile = this.form.mobile;
            obj.module_id = this.form.module_id;
            obj.note = this.form.note;
            if (this.isAdd == 'add') obj.name = this.form.name;
            this.buySubmit(obj);
          } else if (this.isAdd == 'package') {  // 流量包购买
            // console.log(this.form);
            let obj = {
              pay_type: this.form.pay_type,
            }
            obj.org_code = this.form.org_code;
            obj.org_name = this.form.org_name;
            obj.mobile = this.form.mobile;
            obj.name = this.form.name;
            obj.note = this.form.note;
            obj.module_id = this.form.module_id;
            obj.periods = JSON.parse(JSON.stringify(this.form.periods));
            obj.periods = obj.periods.map(item => {
              delete item.index;
              return item
            })
            this.buySubmit(obj);

          }
        }
      });
    },
    buySubmit(obj) {
      let priceObj = {
        pay_type: this.form.pay_type,
        type: this.isAdd == 'package' ? 2 : 1,
        module_id: this.form.module_id,
        buyout:obj.buyout
      };
      let method = buyAFCloud;
      if (this.isAdd != 'package') {
        priceObj.months = this.form.months
      } else {
        priceObj.periods = obj.periods;
        method = buyAFCloudPackagePrice
      }
      buyAFCloudPrice(priceObj)
        .then((res) => {
          this.$store
            .dispatch('user/userinfo') //获取账户余额
            .then(() => {
              this.loading = false;
              console.log(this.$store.getters.userInfo.finance);

              let finance = {
                special: this.$store.getters.userInfo.finance.af_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.price,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, '支付信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  method(Object.assign(obj, priceObj)).then((res) => {
                    this.$message({
                      type: 'success',
                      message: '购买成功!',
                    });
                    this.resetForm();
                    this.visible = false;
                    this.$parent.getAuthData();
                    if(this.isAdd == "module_buy"){
                      this.$parent.refreshAFOrdersApps()
                    }
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消购买',
                  });
                });
            });
        })
        .catch((err) => { });
    },
    modifyBuySubmit(obj) {
      let priceObj = {
        pay_type: this.form.pay_type,
        months: this.form.months,
      };
      addXZMonthPrice(this.modifyId, priceObj)
        .then((res) => {
          this.$store
            .dispatch('user/userinfo') //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.af_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.price,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, '支付信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  addXZMonth(this.modifyId, obj).then((res) => {
                    this.$message({
                      type: 'success',
                      message: '购买成功!',
                    });
                    this.resetForm();
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消购买',
                  });
                });
            });
        })
        .catch((err) => { });
    },
    cancel(formName, close) {
      this.visible = false;
      this.resetForm()
      setTimeout(() => {
        this.modifyId = null;
        this.isAdd = "add";
      }, 100);

    },



    changeMonths(item) {
      if (item.buyout_valid && item.valid) {
        this.buyTime = [
          { name: '一年', value: 12 },
          { name: '两年', value: 24 },
          { name: '三年', value: 36 },
        ];
      } else if (item.valid) {
        this.buyTime = [{ name: '一年', value: 12 }, { name: '两年', value: 24 }, { name: '三年', value: 36 }];
      }
    },


  },
};
</script>
<style lang="scss" scoped>
.xz_buyDialog {
  div {
    // box-sizing: border-box;
  }

  .input_bottom {
    margin-bottom: 10px;
  }

  /deep/ .el-dialog__body {
    padding: 30px 20px 0px 20px !important;
  }

  .ip_valid:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }

  .ip_main {
    .ip_input_main {
      display: inline-block;
      width: 100%;

      .add_span {
        width: 80px;
        text-align: center;
        color: #409eff;
        cursor: pointer;

        i {
          font-size: 20px;
        }
      }
    }
  }

  .ip_main :not(:last-child) {
    margin-bottom: 10px;
  }

  .info {
    margin: 10px 5px;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;

    .input_box {
      padding: 0 50px;
      margin-top: 20px;

      // margin-bottom: 10px;
      .block {
        display: inline-block;
        margin-right: 85px !important;
        margin-top: 0 !important;
        margin-bottom: 10px !important;
        width: 178px;

        .autocomplete {
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0px;
        }
      }

      .block:last-child {
        margin-right: 0 !important;
      }

      .label {
        margin-bottom: 5px;
        font-size: 13px;

        span {
          color: #ff0000;
        }
      }
    }

    .title {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: 1px solid rgb(233, 233, 233);
      font-size: 16px;
      font-weight: 650;
      padding: 15px 20px;
      background: #f9f9f9;
    }
  }

  .company_info {
    padding-bottom: 20px;
  }

  .authorization_info {
    .context {
      padding: 20px 50px;

      p {
        font-size: 13px;
        margin-bottom: 5px;
      }
    }
  }

  .pay_info {
    padding-bottom: 20px;
  }

  .price {
    float: left;
    text-align: left;
    font-size: 16px;

    span {
      color: #ff0000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agileFlow/buyCloud.vue